<template>
  <div>
    <div class="side-frame-success">
      <span style="font-size: 16px; color: #6C6C6C">
        {{ $l('form_label_research_record_details') || '调研记录明细' }}
      </span>
      <el-divider direction="vertical" v-if="!disabled"></el-divider>
      <el-button
        size="mini"
        @click="addStore()"
        v-if="!disabled"
        type="primary"
        plain
        icon="el-icon-plus"
      >
        {{ $l('INDEX.btn_add') || '新增' }}
      </el-button>
    </div>
    <el-card
      class="box-card"
      shadow="never"
      v-for="(item, index) in storeList"
      :key="item.resFabricScmImageCode"
      :body-style="{ padding: '3px 0 0 3px' }"
    >
      <div>
        <el-row class="mb-1">
          <el-col :span="22">
            <div style="display: flex;" class="mr-2">
              <el-image
                :src="
                  item.defaultImageUrl
                    ? $osscdn(item.defaultImageUrl)
                    : '/image/static/img/nopic.jpg'
                "
                style="width:60px; height:60px"
                @click.stop="onScmImagePreview([item.defaultImageUrl], 0)"
              >
                <div slot="error" class="image-slot">
                  <img
                    src="/image/static/img/nopic.jpg"
                    style="width: 100px; height: 66px"
                  />
                </div>
              </el-image>
              <div style="font-size: 14px; color: #101010" class="ml-2">
                <div>店铺名称： {{ item.resFabricScmName || '' }}</div>
                <div>店铺地址：{{ item.resFabricScmAddress || '' }}</div>
                <div>
                  联系方式：
                  <span class="mr-2">
                    {{ item.contactName || '' }}
                  </span>
                  <span class="mr-2">
                    {{ item.contactMobile || '' }}
                  </span>
                  <span>
                    {{ item.contactPhone || '' }}
                  </span>
                  <!-- {{ item.contactMobile || '' }} {{ item.contactPhone || '' }} -->
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="2">
            <div
              style="height:60px; display: flex;justify-content: end; align-items: center;"
              class="mr-3"
            >
              <div class="mr-3" v-show="item.isShowPanel">
                <div style="text-align: center">
                  <el-dropdown trigger="click" @command="storeCommand">
                    <span class="el-dropdown-link">
                      <i class="el-icon-more"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        icon="el-icon-view"
                        :command="{
                          pageType: 'detail',
                          resFabricScmCode: item.resFabricScmCode,
                          resFabricRecordCode: item.resFabricRecordCode,
                        }"
                      >
                        {{ $l('INDEX.btn_view_details') || '查看详情' }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        icon="el-icon-edit"
                        divided
                        :command="{
                          pageType: 'edit',
                          resFabricScmCode: item.resFabricScmCode,
                          resFabricRecordCode: item.resFabricRecordCode,
                          index: index,
                        }"
                        v-if="!disabled"
                      >
                        {{ $l('btn_edit_material') || '编辑资料' }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        icon="el-icon-delete"
                        divided
                        :command="{
                          pageType: 'del',
                          resFabricScmCode: item.resFabricScmCode,
                          index: index,
                        }"
                        v-if="!disabled"
                      >
                        {{ $l('btn_del_material') || '删除资料' }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        icon="el-icon-upload2"
                        divided
                        :command="{
                          pageType: 'addFabric',
                          resFabricScmCode: item.resFabricScmCode,
                          resFabricRecordCode: item.resFabricRecordCode,
                          index: index,
                        }"
                        v-if="!disabled"
                      >
                        {{ $l('btn_add_fabric') || '增加面料' }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div>
                <a
                  role="button"
                  style="color: #606266"
                  @click="changeShowPanel(item, index)"
                >
                  <i
                    v-if="item.isShowPanel"
                    class="el-icon-arrow-down"
                    :title="$l('INDEX.btn_retract') || '收起'"
                  ></i>
                  <i
                    v-else
                    class="el-icon-arrow-right"
                    :title="$l('INDEX.btn_expand') || '展开'"
                  ></i>
                </a>
              </div>
            </div>
          </el-col>
        </el-row>
        <div
          class="card"
          v-if="
            item.isShowPanel &&
              item.fabricInfoList &&
              item.fabricInfoList.length > 0
          "
        >
          <div
            class="mt-1 mr-2"
            v-for="fabricInfo in item.fabricInfoList"
            :key="fabricInfo.resFabricInfoCode"
          >
            <el-card :body-style="{ padding: '3px 0 0 0px' }" shadow="never">
              <div style="display: flex; padding-left:2px;">
                <div style="width:130px; height:130px" class="mr-2">
                  <el-image
                    :src="
                      fabricInfo.thumbImageUrl
                        ? $osscdn(fabricInfo.thumbImageUrl)
                        : '/image/static/img/nopic.jpg'
                    "
                    style="width:130px; height:130px"
                    @click.stop="onImagePreview(fabricInfo.allImage, 0)"
                  >
                    <div slot="error" class="image-slot">
                      <img
                        src="/image/static/img/nopic.jpg"
                        style="width: 130px; height: 130px"
                      />
                    </div>
                  </el-image>
                </div>
                <div style="width:130px; height:130px;">
                  <div class="covers">
                    <div
                      class="cover"
                      v-for="(img, index) in fabricInfo.fabricInfoList"
                      :key="index"
                    >
                      <el-image
                        :src="
                          img ? $osscdn(img) : '/image/static/img/nopic.jpg'
                        "
                        style="width:40px; height:40px"
                        @click.stop="
                          onImagePreview(fabricInfo.allImage, index + 1)
                        "
                      >
                        <div slot="error" class="image-slot">
                          <img
                            src="/image/static/img/nopic.jpg"
                            style="width: 130px; height: 130px"
                          />
                        </div>
                      </el-image>
                    </div>
                  </div>
                </div>
              </div>
              <el-descriptions border size="small" :column="1" class="mt-1">
                <el-descriptions-item
                  :label="$l('INDEX.form_label_fabricNo') || '面料编号'"
                  :labelStyle="{
                    width: '75px',
                    color: '#6C6C6C',
                    fontSize: '14px',
                  }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010',
                    fontSize: '14px',
                  }"
                >
                  <div
                    style="display: flex;justify-content: space-between; align-items: center;"
                  >
                    <div>
                      <span>
                        {{ fabricInfo.fabricNo || '' }}
                      </span>
                    </div>
                    <div style="text-align: center;">
                      <el-dropdown trigger="click" @command="fabricCommand">
                        <span class="el-dropdown-link">
                          <i class="el-icon-more"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            icon="el-icon-view"
                            :command="{
                              pageType: 'detail',
                              resFabricInfoCode: fabricInfo.resFabricInfoCode,
                              resFabricScmCode: item.resFabricScmCode,
                            }"
                          >
                            {{ $l('INDEX.btn_view_details') || '查看详情' }}
                          </el-dropdown-item>
                          <el-dropdown-item
                            icon="el-icon-edit"
                            divided
                            :command="{
                              pageType: 'edit',
                              resFabricInfoCode: fabricInfo.resFabricInfoCode,
                              resFabricScmCode: item.resFabricScmCode,
                            }"
                            v-if="!disabled"
                          >
                            {{ $l('btn_edit_material') || '编辑资料' }}
                          </el-dropdown-item>
                          <el-dropdown-item
                            icon="el-icon-delete"
                            divided
                            :command="{
                              pageType: 'del',
                              resFabricInfoCode: fabricInfo.resFabricInfoCode,
                              resFabricScmCode: item.resFabricScmCode,
                            }"
                            v-if="!disabled"
                          >
                            {{ $l('btn_del_material') || '删除资料' }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item
                  :label="$l('form_label_fabric_name') || '面料名称'"
                  :labelStyle="{
                    width: '75px',
                    color: '#6C6C6C',
                    fontSize: '14px',
                  }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010',
                    fontSize: '14px',
                  }"
                >
                  <div :title="fabricInfo.fabricName" class="title">
                    {{ fabricInfo.fabricName || '' }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item
                  :label="$l('form_label_fty_no') || '厂家编号'"
                  :labelStyle="{
                    width: '75px',
                    color: '#6C6C6C',
                    fontSize: '14px',
                  }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010',
                    fontSize: '14px',
                  }"
                >
                  {{ fabricInfo.ftyNo || '' }}
                </el-descriptions-item>
                <el-descriptions-item
                  :label="$l('form_label_fabric_weight') || '克重'"
                  :labelStyle="{
                    width: '75px',
                    color: '#6C6C6C',
                    fontSize: '14px',
                  }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010',
                    fontSize: '14px',
                  }"
                >
                  {{ fabricInfo.fabricWeight || '0' }}
                  {{ fabricInfo.fabricWeightUnit || '' }}
                </el-descriptions-item>
                <el-descriptions-item
                  :label="$l('form_label_fabric_wid') || '门幅'"
                  :labelStyle="{
                    width: '75px',
                    color: '#6C6C6C',
                    fontSize: '14px',
                  }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010',
                    fontSize: '14px',
                  }"
                >
                  {{ fabricInfo.fabricWid || '0' }}
                  {{ fabricInfo.widUnit || '' }}
                </el-descriptions-item>
                <el-descriptions-item
                  :label="$l('form_label_unitPrice') || '价格'"
                  :labelStyle="{
                    width: '75px',
                    color: '#6C6C6C',
                    fontSize: '14px',
                  }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010',
                    fontSize: '14px',
                  }"
                >
                  {{ fabricInfo.unitPrice || '' }}
                  {{ fabricInfo.fabricUnit || '' }}
                </el-descriptions-item>
                <el-descriptions-item
                  :label="$l('form_label_fabricContent') || '面料成分'"
                  :labelStyle="{
                    width: '75px',
                    color: '#6C6C6C',
                    fontSize: '14px',
                  }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010',
                    fontSize: '14px',
                  }"
                >
                  <div :title="fabricInfo.fabricContent" class="title">
                    {{ fabricInfo.fabricContent || '' }}
                  </div>
                </el-descriptions-item>
              </el-descriptions>
            </el-card>
          </div>
        </div>
        <!-- </b-collapse> -->
      </div>
    </el-card>
    <el-card v-if="!storeList || storeList.length == 0">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </el-card>

    <EditStore
      :visible.sync="editStoreOptions.visible"
      :resFabricScmCode="editStoreOptions.code"
      :resFabricRecordCode="editStoreOptions.resFabricRecordCode"
      :disabled="editStoreOptions.disabled"
      @reload="getStoreIndexData"
    />
    <EditFabric
      :visible.sync="editFabricOptions.visible"
      :resFabricInfoCode="editFabricOptions.code"
      :resFabricScmCode="editFabricOptions.resFabricScmCode"
      :disabled="editFabricOptions.disabled"
      @reload="getStoreIndexData"
    />
    <FabricImage
      v-if="fabricImageOptions.visible"
      @closeImage="closeImage"
      :visible.sync="fabricImageOptions.visible"
      :resFabricScmCode="fabricImageOptions.code"
      :resFabricRecordCode="fabricImageOptions.resFabricRecordCode"
      :title="$l('form_label_upload_fabric_images') || '上传面料图片'"
    />
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import BaseTable from '@/mixins/base-table'
import EditStore from './edit-store'
import EditFabric from './edit-store-fabric'
import FabricImage from './fabric-image'

export default {
  mixins: [EditLoading, BaseTable],
  components: { EditStore, FabricImage, EditFabric },
  props: {
    resFabricRecordCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      title: '',
      formData: {},
      editStoreOptions: {
        visible: false,
        code: '',
        resFabricRecordCode: '',
        disabled: false,
      },
      editFabricOptions: {
        visible: false,
        code: '',
        resFabricScmCode: '',
        disabled: false,
      },
      fabricImageOptions: {
        visible: false,
        code: '',
        resFabricRecordCode: '',
        disabled: false,
      },
      isShowPanel: false,
      storeList: [],
      storeIndex: null,
      resFabricScmCode: '',
      listImageUrl: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    changeShowPanel(item, index) {
      item.isShowPanel = !item.isShowPanel
      this.storeIndex = index
      this.resFabricScmCode = item.resFabricScmCode
      this.storeList.splice(index, 1, item)
      if (item.isShowPanel) this.getStoreIndexData()
    },
    getData() {
      if (!this.resFabricRecordCode) return
      this.loadingOpen()
      this.$api
        .resFabricScmPcListContainFabricApi({
          resFabricRecordCode: this.resFabricRecordCode,
          isLocalImg: 'N',
        })
        .then((res) => {
          this.loadingClose()
          this.storeList = res.body.data
          this.storeList.forEach((f) => (f.isShowPanel = true))
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    getStoreIndexData() {
      if (!this.resFabricScmCode) return
      this.loadingOpen()
      this.$api
        .resFabricScmPcDetailContainFabricApi({
          resFabricScmCode: this.resFabricScmCode,
          isLocalImg: 'N',
        })
        .then((res) => {
          this.loadingClose()
          const item = res.body
          item.isShowPanel = true
          this.storeList.splice(this.storeIndex, 1, item)
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    addStore() {
      this.loadingOpen()
      this.$api
        .resFabricScmPcAddSaveApi({
          resFabricRecordCode: this.resFabricRecordCode,
        })
        .then(async (res) => {
          this.loadingClose()
          if (!res) return
          const { status, body } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          const { resFabricScmCode = '', resFabricRecordCode = '' } = body || {}
          if (resFabricScmCode) {
            this.editStoreOptions = {
              visible: true,
              code: resFabricScmCode,
              resFabricRecordCode: resFabricRecordCode,
              disabled: false,
            }
            this.resFabricScmCode = resFabricScmCode
            this.storeIndex = this.storeList ? this.storeList.length : 0
            this.getData()
            return
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    storeCommand(command) {
      const { pageType, resFabricScmCode, resFabricRecordCode, index } = command
      this.storeIndex = index
      this.resFabricScmCode = resFabricScmCode
      switch (pageType) {
        case 'detail':
        case 'edit':
          this.editStoreOptions.visible = true
          this.editStoreOptions.disabled = pageType === 'detail'
          this.editStoreOptions.code = resFabricScmCode
          this.editStoreOptions.resFabricRecordCode = resFabricRecordCode
          break
        case 'del':
          this.delStore({ resFabricScmCode })
          break
        case 'addFabric':
          this.fabricImageOptions.visible = true
          this.fabricImageOptions.code = resFabricScmCode
          this.fabricImageOptions.resFabricRecordCode = resFabricRecordCode
          break
        default:
          return
      }
    },
    fabricCommand(command) {
      const { pageType, resFabricInfoCode, resFabricScmCode } = command
      this.storeIndex = this.storeList.findIndex(
        (f) => f.resFabricScmCode == resFabricScmCode
      )
      this.resFabricScmCode = resFabricScmCode
      switch (pageType) {
        case 'detail':
        case 'edit':
          this.editFabricOptions.visible = true
          this.editFabricOptions.disabled = pageType === 'detail'
          this.editFabricOptions.code = resFabricInfoCode
          this.editFabricOptions.resFabricScmCode = resFabricScmCode
          break
        case 'del':
          this.delFabric({ resFabricInfoCode })
          break
        default:
          return
      }
    },
    delStore(resFabricScmCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.resFabricScmDelApi(resFabricScmCode).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.getData()
        })
      })
    },
    delFabric(resFabricInfoCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.resFabricInfoDelApi(resFabricInfoCode).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.getStoreIndexData()
        })
      })
    },
    closeImage() {
      this.fabricImageOptions.visible = false
      this.getStoreIndexData()
    },
    onImagePreview(imgList, index) {
      if (!imgList && !imgList.length) return
      this.listImageUrl = imgList
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    onScmImagePreview(imgList, index) {
      if (!imgList && !imgList.length) return
      this.listImageUrl = imgList
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px 0 5px;
  border-left: 3px solid $color-primary;
  height: 26px;
}

::v-deep .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 2px 0 0 0;
}

.covers {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.cover {
  display: flex;
  justify-content: center;
  width: 40px;
  margin-bottom: 5px;
  margin-right: 2px;
}
.border-detail-main-form {
  margin-top: -1px;
}
.title {
  width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.box-card {
  border-radius: 0px;
  border: none;
  border-top: 2px solid #ebeef5;
}
.card {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  justify-content: space-around;
}
</style>
